module.exports = __webpack_public_path__ + "img/30.78f10105.png";